// extracted by mini-css-extract-plugin
module.exports = {"tags":"Tags-module--tags--13gx_","tag":"Tags-module--tag--flc2e","more":"Tags-module--more--2ZVVU"};